// @ts-nocheck
import _get from 'lodash/get'
import moment from 'moment-timezone'
import { formatUTCDate } from 'utils/formatDatetime'
import { validatePhone, validateEmail } from 'utils/validators'
import { FORMATS } from 'constants/datetime'

export const isExpired = (date: string) =>
  date && moment.utc().isAfter(moment.utc(date, FORMATS.dateFormat))

export const getExpiredInsurances = ({ auto, autoUmbrella, cargo }) =>
  [
    isExpired(auto) && `Automobile Liability expired ${formatUTCDate(auto)}`,
    isExpired(autoUmbrella) &&
      `Automobile Liability Umbrella Coverage expired ${formatUTCDate(autoUmbrella)}`,
    isExpired(cargo) && `Cargo Coverage Liability expired ${formatUTCDate(cargo)}`,
  ]
    .filter(x => x)
    .join(' · ')

export const getClosestExpiringInsurance = ({ auto, autoUmbrella, cargo }) =>
  [auto, autoUmbrella, cargo]
    .filter(x => x)
    .map(date => moment.utc(date, FORMATS.dateFormat).valueOf())
    .sort((a, b) => a - b)
    .slice(0, 1) // take first (min) entry
    .map(date => `Next policy expires ${moment.utc(date).format(FORMATS.dateFormat)}`)
    .join('')

export const getInsuranceSummary = ({
  automotiveInsurance: { expirationDate: auto, umbrellaExpirationDate: autoUmbrella } = {},
  cargoInsurance: { expirationDate: cargo } = {},
} = {}) => {
  const expirationDates = { auto, autoUmbrella, cargo }
  return getExpiredInsurances(expirationDates) || getClosestExpiringInsurance(expirationDates)
}

export const getInsurances = ({
  automotiveInsurance = {},
  generalInsurance = {},
  cargoInsurance = {},
  trailerInterchangeInsurance = {},
  dishonestyInsurance = {},
  workersCompensationInsurance = {},
} = {}) => ({
  automotiveInsurance,
  generalInsurance,
  cargoInsurance,
  trailerInterchangeInsurance,
  dishonestyInsurance,
  workersCompensationInsurance,
})

export const getInsuranceReviewer = carrierApplication =>
  _get(carrierApplication, 'opsCarrierChecklist.insuranceDetailsReviewedBy')

export const prefixIds = (list, prefix) =>
  list.map(entry => ({
    ...entry,
    id: `${prefix}-${entry.id}`,
  }))

export const isInsuranceValid = ({
  automotiveInsurance: { contactInfo: auto } = {},
  generalInsurance: { contactInfo: general } = {},
  cargoInsurance: { contactInfo: cargo } = {},
  trailerInterchangeInsurance: { contactInfo: trailer } = {},
  dishonestyInsurance: { contactInfo: dishonesty } = {},
  workersCompensationInsurance: { contactInfo: workers } = {},
}) =>
  [general, auto, cargo, trailer, dishonesty, workers].every(contactInfo => {
    const { email, fax, phone } = contactInfo || {}
    return (
      (!email || validateEmail(email)) &&
      (!phone || validatePhone(phone)) &&
      (!fax || validatePhone(fax))
    )
  })
